module.exports = __webpack_public_path__ + "img/chart-flowers-3-2x.598653ff.png";